import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { VerticalDivider } from '@ecp/common/src/layouts/flex/styled';
import { TextButton } from '@ecp/common/src/components/button/bo/TextButton';

const PoPersonalInfoChange = () => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate('/partner/member/change-personal-info');
  }, [navigate]);

  return (
    <>
      <VerticalDivider height="6px" />
      <TextButton onClick={handleClick}>계정정보수정</TextButton>
    </>
  );
};

export default PoPersonalInfoChange;
